module.exports = __webpack_public_path__ + "static/img/myserver3.8092583.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/myserver3.png
// module id = p2n4
// module chunks = 2